export default __webpack_public_path__ + "static/media/doc-english.4d50a66b.pdf";